const WebSocketMessageNameConstants = {
    LISTING_SYNDICATION_STATUS: 'listingSyndicationStatus',
    EMAIL_VERIFIED: 'emailVerified',
    USER_FEED_TO_MANUAL_STATUS: 'userFeedToManualStatuses',
};

export default WebSocketMessageNameConstants;
